module.exports = __webpack_public_path__ + "static/media/dropdown.a5ba8b0d.svg";